export const CDP_COMPANY_ID = "81548ae1-c67e-4faa-8bd0-252977f11f3a";
export const SNAM_COMPANY_ID = "e63a3e16-8827-4c63-8224-b7c4294c45dd";
export const DIGITALATTITUDE_COMPANY_ID =
  "5706867a-c563-4ca5-b803-c1883c38b640";
export const ANGELINI_COMPANY_ID = "9aa46b2c-5fa6-4f0c-839d-35527dd19386";

export const getUserCompanies = (user) =>
  Array.isArray(user?.companies) ? user.companies : [];

export const isCdpOnlyUser = (user) => {
  const companies = getUserCompanies(user);
  return companies.length === 1 && companies[0] === CDP_COMPANY_ID;
};

export const isSnamOnlyUser = (user) => {
  const companies = getUserCompanies(user);
  return companies.length === 1 && companies[0] === SNAM_COMPANY_ID;
};

/**
 * @deprecated No longer used for gating. HR Documents is available to anyone who
 * sees the Welfares tabs (Admin or Angelini), same as WelfareList.
 * Kept as an alias of that access rule for backwards compatibility.
 */
export const canAccessHrDocumentsUi = (user) => {
  const groups = Array.isArray(user?.groups) ? user.groups : [];
  const companies = getUserCompanies(user);
  return groups.includes("Admins") || companies.includes(ANGELINI_COMPANY_ID);
};
